import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { baseURL } from "../../App";

const Login = ({ setIsAuthenticated }) => {
  const API_URL = `${baseURL}/api/users/login`;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        API_URL,
        { email, password },
        { withCredentials: true } // Include cookies in the request
      );

      if (response.status === 200) {
        // Assuming the token is in the response.data.token
        Cookies.set("token", response.data.token, { path: "/" }); // Store the token in cookies
        setIsAuthenticated(true);
        navigate("/admin/dashboard");
      } else {
        alert("Invalid credentials, please try again.");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Invalid credentials, please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Admin Login</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button className="btn btnPrimary" type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
